<eo-search-page
  [formConfig]="formConfig"
  [tableConfig]="tableConfig"
  [searchServ]="searchService"
  [page]="getPage()"
  [pagesize]="getPagesize()"
  [totalCount]="getTotalCount()"
  [loading]="isLoading()"
  [viewModeVisible]="false"
  [menuActions]="[]"
  (search)="onSearch($event)"
  [customFormControls]="{
    clinicID: clinicID
  }"
  [initData]="true"
  [collapsed]="true"
  [actionMenuVisible]="false"
>
  <ng-template
    #clinicID
    let-formGroup="formGroup"
    let-config="config"
    let-styleClass="styleClass"
  >
    <ng-container [formGroup]="formGroup">
      <app-clinic-dropdown
        [label]="config.label"
        [class]="styleClass"
        [config]="config"
        formControlName="clinicID"
        [hospitalId]="tokenData?.hospitalId"
        [showClear]="tokenData?.clinicId == null"
      />
    </ng-container>
  </ng-template>
  <ng-container actions>
    <p-button
      size="small"
      label="Νέα Διαθεσιμότητα"
      icon="pi pi-plus"
      [disabled]="isLoading()"
      (onClick)="onCreateHospitalAvailability()"
    />
  </ng-container>
</eo-search-page>

<app-hospital-availability-form-dialog
  #hospitalAvailabilityFormDialog
  (success)="onHospitalAvailabilityFormSuccess()"
/>

<p-confirmPopup
  key="deleteHospitalAvailabilityPopup"
  [style]="{ width: '700px' }"
>
</p-confirmPopup>
